import * as D from './deps';
import * as DrmWorkers from './sagas';

export default D.createDomainModule({
  name: 'drm',
  components: {},
  reducer: null,
  onLoad() {},
  onStart() {
    this.registeredHandlers = D.registerHandlers([
      {
        actionType: D.Constants.Playback.ActionTypes.LOG_DRM_RECEIPT,
        handler: DrmWorkers.logReceiptDRM,
        concur: 'takeEvery',
      },
      {
        actionType: D.Constants.Playback.ActionTypes.LOG_SKIP_FOR_DRM,
        handler: DrmWorkers.logSkipDRMWatcher,
        concur: 'takeEvery',
      },
      {
        actionType: D.Constants.Integrations.ActionTypes.TRACK_INTERRUPTED,
        handler: DrmWorkers.onTrackInterrupted,
        concur: 'takeEvery',
      },
    ]);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
